<div class="dialog-container">
  <div class="dialog-header">
    <h4 class="dialog-heading">New Campaign</h4>
    <button type="button" class="close-button" (click)="close()">
      <svg width="26px" height="24px" viewBox="0 0 26 24" version="1.1" xmlns="http://www.w3.org/2000/svg">
        <g stroke="none" stroke-width="1" fill="none" fill-rule="evenodd" stroke-linecap="round" stroke-linejoin="round">
          <g class="inner-stroke" stroke="#FFFFFF">
            <path d="M24,0 L0,24" id="Path"></path>
            <path d="M0,0 L24,24" id="Path"></path>
          </g>
        </g>
      </svg>
    </button>
  </div>

  <mat-dialog-content class="p-25">
    <app-loader *ngIf="loading" color="#50e3c2"></app-loader>
    <p class="error" *ngIf="error">{{error}}</p>

    <!-- Step 0: select template -->
    <div class="dialog-body" *ngIf="step === 'template'">
      <div class="form-row green-theme">
        <mat-radio-group [(ngModel)]="templateTab" (change)="switchTemplateTab(templateTab)">
          <mat-radio-button name="templateTab" [value]="'clients'">Client</mat-radio-button>
          <mat-radio-button name="templateTab" [value]="'artists'">Artist</mat-radio-button>
        </mat-radio-group>
      </div>
      <form
        action="#"
        class="search-filter"
        #templateSearchForm="ngForm"
        (ngSubmit)="$event.preventDefault();submitTemplateSearch()"
        [ngClass]="{'search-filter-focused': templateSearchFocused}">
        <label for="campaign-template-search-field" class="icon" (click)="submitTemplateSearch()">
          <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14"><path fill="none" stroke="#fff" stroke-linecap="round" stroke-linejoin="round" stroke-miterlimit="20" d="M6 1a5 5 0 110 10A5 5 0 016 1zM13.002 13.002L9.535 9.535"/></svg>
        </label>
        <input
          [(ngModel)]="templateSearchString"
          name="templateSearchString"
          type="text"
          class="txt"
          id="campaign-template-search-field"
          (focus)="templateSearchFocused = true"
          placeholder="Find a template"/>
      </form>
      <app-loader *ngIf="loadingTemplates || loadingTemplateDetail" color="#50e3c2"></app-loader>
      <ul class="templates" *ngIf="!loadingTemplates && !loadingTemplateDetail">
        <li *ngFor="let template of templates" (click)="selectTemplate(template)">
          {{template.getDisplayName()}}
        </li>
        <li class="note" *ngIf="templates.length === 0">No templates found.</li>
      </ul>
    </div>

    <!-- Step 1: recipients (same fields/styling as the template dialog's edit form) -->
    <div class="dialog-body" *ngIf="step === 'recipients'">
      <p class="note">Template: {{selectedTemplate?.getDisplayNameOnly ? selectedTemplate.getDisplayNameOnly() : selectedTemplate?.name}}</p>
      <div class="grid-container">
        <div class="grid-item">
          <mat-form-field appearance="fill">
            <mat-label>From</mat-label>
            <mat-select [(ngModel)]="fromEmail">
              <mat-option *ngFor="let user of fromEmailOptions" [value]="user.email">{{user.email}}</mat-option>
            </mat-select>
          </mat-form-field>
        </div>
      </div>
      <div class="grid-container">
        <div class="grid-item">
          <mat-form-field appearance="fill" floatLabel="always">
            <mat-label>To (Group)</mat-label>
            <mat-select panelClass="templatepanel" [disableOptionCentering]="true" placeholder="Select" [(ngModel)]="recipientGroupIds" [disabled]="loadingGroups" multiple>
              <mat-option>
                <ngx-mat-select-search
                  [searching]="searchingGroups"
                  [formControl]="groupSearchCtrl"
                  placeholderLabel="Select Group"
                  noEntriesFoundLabel="No Options Found">
                </ngx-mat-select-search>
              </mat-option>
              <mat-option *ngFor="let group of filteredGroupOptions | async" [value]="group.id">
                {{group.name}}
              </mat-option>
            </mat-select>
          </mat-form-field>
          <app-loader *ngIf="loadingGroups" color="#50e3c2" [isHalfSize]="true" textDisplay="Loading groups…"></app-loader>
        </div>
        <div class="grid-item">
          <mat-form-field appearance="fill">
            <mat-label>To (single Individual)</mat-label>
            <input type="email" matInput [(ngModel)]="individualRecipient">
          </mat-form-field>
        </div>
      </div>
      <div class="grid-container">
        <div class="grid-item">
          <mat-form-field appearance="fill">
            <mat-label>Add (cc)</mat-label>
            <input type="email" matInput [(ngModel)]="ccInput">
          </mat-form-field>
        </div>
        <div class="grid-item">
          <mat-form-field appearance="fill">
            <mat-label>Add (BCC)</mat-label>
            <input type="email" matInput [(ngModel)]="bccInput">
          </mat-form-field>
        </div>
      </div>
      <div class="grid-container">
        <div class="grid-item full-width">
          <mat-form-field appearance="fill">
            <mat-label>Subject</mat-label>
            <input matInput [(ngModel)]="subject">
          </mat-form-field>
        </div>
      </div>
      <div class="title">
        <h6>Message</h6>
      </div>
      <ckeditor
        [editor]="Editor"
        [config]="editorConfig"
        [(ngModel)]="body"
        (ready)="onReady($event)"
      ></ckeditor>
      <p class="note">Use {{NickName}} to insert clients nickname into message</p>
      <p class="note">Use {{FirstName}} to insert clients firstname into message</p>

      <div class="add-to-folder form-container">
        <h6 class="label">Add playlist<span class="deselect"><small> {{playListArrayNames.length}} Playlists </small></span></h6>
        <form
          action="#"
          class="search-filter"
          #playlistSearchForm="ngForm"
          (ngSubmit)="$event.preventDefault();submitPlaylistSearch()"
          [ngClass]="{'search-filter-focused': playlistSearchFocused}">
          <label for="campaign-playlist-search-field" class="icon" (click)="submitPlaylistSearch()">
            <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14"><path fill="none" stroke="#fff" stroke-linecap="round" stroke-linejoin="round" stroke-miterlimit="20" d="M6 1a5 5 0 110 10A5 5 0 016 1zM13.002 13.002L9.535 9.535"/></svg>
          </label>
          <input
            [(ngModel)]="playlistSearchString"
            name="playlistSearchString"
            type="text"
            class="txt"
            id="campaign-playlist-search-field"
            (focus)="playlistSearchFocused = true"
            placeholder="Find a playlist"/>
        </form>
        <app-loader *ngIf="loadingPlaylists" color="#50e3c2"></app-loader>
        <ul class="playlist-list" *ngIf="!loadingPlaylists">
          <li *ngFor="let playlist of playlistArray">
            <mat-checkbox [checked]="playlist.checked" (change)="togglePlaylist(playlist, $event)">
              <span class="check-text">{{playlist.created_at | date:'shortDate'}} - {{playlist.name}}</span>
            </mat-checkbox>
            <mat-checkbox (change)="toggleAddToRecipientAccount(playlist, $event)">
              <span class="check-text">Add to recipients account</span>
            </mat-checkbox>
            <span class="copy-link" (click)="copyPlaylistLink(playlist)">
              <img class="uploadwidth" src="assets/img/link-solid.svg"> Copy link
            </span>
          </li>
          <li *ngIf="playlistArray.length === 0" class="note">No playlists found.</li>
        </ul>
        <button *ngIf="!playlistSearchString || searchResultsCount > playlistArray.length" class="btn save-btn" style="padding: 0px;margin-top:10px;width: 100px;height: 25px;" (click)="loadMorePlaylists()">Load More</button>
      </div>

      <p class="error" *ngIf="recipientsError">{{recipientsError}}</p>
      <div class="form-col">
        <button class="form-button form-button-cancel" (click)="backToTemplateStep()">Back</button>
        <button class="form-button" (click)="proceedToPreview()">Preview Recipients</button>
      </div>
    </div>

    <!-- Step 2: preview -->
    <div class="dialog-body" *ngIf="step === 'preview' && !loading">
      <div class="form-row" *ngIf="previewResponse">
        <p><strong>{{previewResponse.deduplicated_recipient_count}}</strong> unique recipients ({{previewResponse.resolved_recipient_count}} resolved)</p>
        <p *ngIf="previewResponse.excluded_invalid_addresses.length > 0" class="note">
          Excluded invalid addresses: {{previewResponse.excluded_invalid_addresses.join(', ')}}
        </p>
        <p *ngIf="previewResponse.invalid_bcc_addresses.length > 0" class="note">
          Invalid BCC addresses: {{previewResponse.invalid_bcc_addresses.join(', ')}}
        </p>
        <p *ngFor="let w of previewResponse.warnings" class="note">{{w}}</p>

        <mat-form-field appearance="fill">
          <mat-label>BCC Policy</mat-label>
          <mat-select [(ngModel)]="bccPolicy" (selectionChange)="runPreview()">
            <mat-option value="SEPARATE_SUMMARY">Separate summary (default)</mat-option>
            <mat-option value="EVERY_MESSAGE">Every message</mat-option>
            <mat-option value="FIRST_MESSAGE_ONLY">First message only (legacy)</mat-option>
          </mat-select>
        </mat-form-field>
        <mat-form-field appearance="fill">
          <mat-label>BCC address</mat-label>
          <input type="email" matInput [(ngModel)]="bccInput" (blur)="runPreview()" placeholder="e.g. audit@example.com">
        </mat-form-field>

        <p class="warning-note" *ngIf="!bccInput">
          No BCC address is set, so no summary/copy will be sent regardless of the policy above. Enter one here if you want a BCC.
        </p>

        <p class="note" *ngIf="zeroRecipients">
          No recipients resolved. The campaign can be created as a draft, but sending will fail.
        </p>
      </div>
      <div class="form-col">
        <button class="form-button form-button-cancel" (click)="backToRecipientsStep()">Back</button>
        <button class="form-button" (click)="createCampaign()">Create Campaign</button>
        <button class="form-button form-button-cancel" (click)="close()">Cancel</button>
      </div>
    </div>

    <!-- Step 2: confirm BCC policy -->
    <div class="dialog-body" *ngIf="step === 'confirm' && !loading">
      <div class="form-row" *ngIf="createResponse">
        <p><strong>{{createResponse.intended_recipient_count}}</strong> intended recipients</p>
        <p>BCC Policy: <strong>{{createResponse.bcc_policy}}</strong> &middot; BCC address: <strong>{{bccInput || 'none'}}</strong></p>
        <p class="note" *ngIf="previewResponse">{{previewResponse.bcc_policy_effect}}</p>
        <p class="warning-note" *ngIf="!bccInput">
          No BCC address is set - nothing will be sent for the BCC policy above.
        </p>
        <p class="note" *ngIf="createResponse.intended_recipient_count === 0">
          Sending is blocked because there are no intended recipients.
        </p>
      </div>
      <div class="form-col">
        <button class="form-button form-button-cancel" (click)="backToPreviewStep()">Back</button>
        <button class="form-button" (click)="sendCampaign()" [disabled]="createResponse?.intended_recipient_count === 0">Send Campaign</button>
        <button class="form-button form-button-cancel" (click)="close()">Cancel</button>
      </div>
    </div>

    <!-- Step 3/4: sending + status -->
    <div class="dialog-body" *ngIf="step === 'sending' || step === 'status'">
      <app-campaign-status-bar [status]="campaignStatus" [pollError]="pollError" [pollFailed]="pollFailed"></app-campaign-status-bar>
      <div class="form-col" *ngIf="campaignStatus?.is_terminal || pollFailed">
        <button class="form-button form-button-cancel" (click)="close()">Close</button>
      </div>
    </div>
  </mat-dialog-content>
</div>
